import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { PagedItemsDatasource } from "src/app/components/base-classes/paged-items-datasource";
import { Page_VenueTemplate_, Venue, VenueService, VenueTemplate } from "src/app/planvue-api";

export class VenueTemplatesDataSource extends PagedItemsDatasource<VenueTemplate> {
    private venueService: VenueService = inject(VenueService);
    public venue!: Venue;
    public columns: string[] = ["title", "filename", "format", "delete"];
    
    constructor() {
        super();
    }

    override requestItems(pageIndex:number, pageSize: number): Observable<Page_VenueTemplate_> {
        return this.venueService.getVenueTemplates(this.venue.id!, pageIndex + 1, pageSize);
    }
}